import React from "react";
import { useTranslation } from "react-i18next";
import { SubPage, FullDivider } from "./SubPage";
export function Blog() {
  const { t, i18n } = useTranslation("blog");
  const posts = t("posts", { returnObjects: true }) as { title: string; date: string; reading: number; summary: string; tags: string[] }[];
  const lang = i18n.language?.startsWith("en") ? "en-US" : "de-DE";

  const formatDate = (dateStr: string) =>
    new Date(dateStr).toLocaleDateString(lang, { month: "short", day: "numeric", year: "numeric" });

  return (
    <SubPage title={t("title")} subtitle={t("subtitle")}>
      <div className="grid grid-cols-1 gap-px bg-grey-800">
        {posts.map((post, i) => (
          <article key={post.title} className="bg-grey-975 px-5 sm:px-8 md:px-[66px] py-8 md:py-10">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-[11px] text-white/25">{formatDate(post.date)}</span>
              <span className="text-[11px] text-white/15">·</span>
              <span className="text-[11px] text-white/25">{post.reading} {t("readingSuffix")}</span>
            </div>
            <h3 className="text-base font-semibold text-white mb-2">{post.title}</h3>
            <p className="text-xs text-white/40 leading-relaxed mb-4">{post.summary}</p>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {post.tags.map((tag) => (
                  <span key={tag} className="text-[9px] text-white/20 font-mono px-1.5 py-0.5 bg-white/[0.03]">{tag}</span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
      <FullDivider />

      <div className="px-5 sm:px-8 md:px-[66px] py-10 md:py-12">
        <p className="text-white/30 text-xs">
          {t("footerNoteBefore")}{" "}
          <a href="mailto:contact@cero-ai.com" className="text-white/50 hover:text-white transition-colors underline underline-offset-2 decoration-white/15 hover:decoration-white/40">
            contact@cero-ai.com
          </a>
        </p>
      </div>
    </SubPage>
  );
}
